(() => {
  const root = document.querySelector('[data-deoro-ai]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  const configNode = document.getElementById('DeOroAiConfig');
  const config = configNode ? JSON.parse(configNode.textContent) : {};
  const panel = root.querySelector('.deoro-ai__panel');
  const opener = root.querySelector('[data-ai-open]');
  const closer = root.querySelector('[data-ai-close]');
  const form = root.querySelector('[data-ai-form]');
  const input = root.querySelector('[data-ai-input]');
  const send = root.querySelector('[data-ai-send]');
  const messages = root.querySelector('[data-ai-messages]');
  const spanish = String(config.locale || '').toLowerCase().startsWith('es');
  let conversationId = sessionStorage.getItem('deoro_ai_conversation') || '';
  let busy = false;

  function setOpen(open) {
    panel.hidden = !open;
    opener.setAttribute('aria-expanded', String(open));
    if (open) setTimeout(() => input.focus(), 20);
  }

  function addMessage(text, role, extraClass = '') {
    const node = document.createElement('div');
    node.className = `deoro-ai__message deoro-ai__message--${role} ${extraClass}`;
    node.textContent = text;
    messages.appendChild(node);
    messages.scrollTop = messages.scrollHeight;
    return node;
  }

  function renderProducts(products) {
    if (!Array.isArray(products) || !products.length) return;
    const list = document.createElement('div');
    list.className = 'deoro-ai__products';
    products.slice(0, 4).forEach((product) => {
      const card = document.createElement('div');
      card.className = 'deoro-ai__product';
      const image = document.createElement('img');
      image.src = product.image || '';
      image.alt = '';
      image.loading = 'lazy';
      const info = document.createElement('div');
      const title = document.createElement('strong');
      title.textContent = product.title || '';
      const price = document.createElement('span');
      price.textContent = product.price || '';
      const link = document.createElement('a');
      link.href = product.url || '#';
      link.textContent = spanish ? 'Ver detalles' : 'View details';
      link.style.fontSize = '11px';
      info.append(title, price, document.createElement('br'), link);
      if (product.variantId && product.available) {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = spanish ? 'Agregar al carrito' : 'Add to cart';
        button.addEventListener('click', () => addToCart(product.variantId, button));
        info.appendChild(button);
      }
      card.append(image, info);
      list.appendChild(card);
    });
    messages.appendChild(list);
    messages.scrollTop = messages.scrollHeight;
  }

  function renderHandoff(handoff, originalQuestion) {
    if (!handoff || !config.endpoint) return;
    const wrap = document.createElement('form');
    wrap.className = 'deoro-ai__handoff';
    wrap.innerHTML = `
      <strong>${spanish ? 'Te responderá una persona' : 'A person will follow up'}</strong>
      <p>${spanish ? 'Déjanos tu correo o teléfono y enviaremos tu pregunta al equipo de De Oro.' : 'Leave your email or phone and we’ll send your question to the De Oro team.'}</p>
      <input name="name" maxlength="100" autocomplete="name" placeholder="${spanish ? 'Nombre' : 'Name'}">
      <input name="email" maxlength="200" type="email" autocomplete="email" placeholder="Email">
      <input name="phone" maxlength="40" type="tel" autocomplete="tel" placeholder="${spanish ? 'Teléfono (opcional)' : 'Phone (optional)'}">
      <button type="submit">${spanish ? 'Enviar al equipo' : 'Send to the team'}</button>
      <small data-handoff-status></small>`;
    wrap.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = wrap.querySelector('button');
      const status = wrap.querySelector('[data-handoff-status]');
      const values = Object.fromEntries(new FormData(wrap));
      if (!values.email && !values.phone) {
        status.textContent = spanish ? 'Incluye un correo o teléfono.' : 'Please include an email or phone.';
        return;
      }
      button.disabled = true;
      try {
        const response = await fetch(config.endpoint.replace(/\/$/, '') + '/api/handoff', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ...values, question: handoff.summary || originalQuestion, category: handoff.category, productUrl: location.href })
        });
        const result = await response.json();
        if (result.delivered) {
          status.textContent = spanish ? 'Enviado. El equipo te responderá pronto.' : 'Sent. The team will follow up soon.';
          button.remove();
          window.dataLayer?.push({ event: 'ai_human_handoff', category: handoff.category || 'other' });
        } else if (result.contactUrl) {
          const link = document.createElement('a');
          link.href = result.contactUrl;
          link.textContent = spanish ? 'Continuar en la página de contacto' : 'Continue on the contact page';
          status.replaceChildren(link);
        } else throw new Error('handoff');
      } catch (_) {
        status.textContent = spanish ? 'No se pudo enviar. Usa la página de contacto.' : 'Could not send. Please use the contact page.';
        button.disabled = false;
      }
    });
    messages.appendChild(wrap);
    messages.scrollTop = messages.scrollHeight;
  }

  async function addToCart(variantId, button) {
    button.disabled = true;
    try {
      const response = await fetch(config.cartAddUrl || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!response.ok) throw new Error('cart');
      button.textContent = spanish ? 'Agregado ✓' : 'Added ✓';
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:open'));
      window.dataLayer?.push({ event: 'ai_add_to_cart', variant_id: String(variantId) });
    } catch (_) {
      button.disabled = false;
      button.textContent = spanish ? 'No se pudo agregar' : 'Could not add';
    }
  }

  function localAnswer(question) {
    const q = question.toLowerCase();
    if (/10k|14k|18k|karat|quilate/.test(q)) {
      return spanish
        ? 'El oro de 10K es más resistente y accesible; 14K equilibra pureza y durabilidad; 18K tiene un color más intenso y mayor contenido de oro, pero es más suave. Puedo ayudarte a elegir según el uso y presupuesto.'
        : '10K gold is durable and budget-friendly; 14K balances purity and everyday strength; 18K has richer color and more gold, but is softer. I can help choose based on wear and budget.';
    }
    if (/return|refund|devolu|shipping|envío|envio/.test(q)) {
      return spanish
        ? 'De Oro ofrece envío gratis y devoluciones sin complicaciones dentro de 30 días. Confirma las condiciones aplicables en la página de políticas antes de comprar.'
        : 'De Oro offers free shipping and hassle-free returns within 30 days. Please confirm the applicable conditions on the policy page before purchasing.';
    }
    return spanish
      ? 'El asesor inteligente todavía necesita conectarse al servicio seguro. Mientras tanto, puedes explorar las colecciones o contactar al equipo de De Oro para una recomendación personalizada.'
      : 'The intelligent concierge still needs its secure service connection. Meanwhile, you can browse the collections or contact the De Oro team for a personal recommendation.';
  }

  function cleanPageText(value, limit) {
    return String(value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/[ \t]+/g, ' ')
      .replace(/\n\s*\n+/g, '\n')
      .trim()
      .slice(0, limit);
  }

  function currentPageContext() {
    const contentRoot = document.querySelector('main, [role="main"], #MainContent') || document.body;
    const copy = contentRoot.cloneNode(true);
    copy.querySelectorAll([
      '[data-deoro-ai]',
      'script',
      'style',
      'noscript',
      'template',
      'svg',
      'canvas',
      'video',
      'audio',
      'input',
      'textarea',
      'select',
      '[hidden]',
      '[aria-hidden="true"]'
    ].join(',')).forEach((node) => node.remove());

    const controls = Array.from(document.querySelectorAll('button, a, [role="button"]'))
      .filter((node) => !node.closest('[data-deoro-ai]'))
      .map((node) => cleanPageText(node.innerText || node.textContent || node.getAttribute('aria-label') || node.getAttribute('title'), 140))
      .filter(Boolean)
      .filter((label, index, labels) => labels.indexOf(label) === index)
      .slice(0, 80);

    const headings = Array.from(document.querySelectorAll('h1, h2, h3'))
      .filter((node) => !node.closest('[data-deoro-ai]'))
      .map((node) => cleanPageText(node.innerText || node.textContent, 180))
      .filter(Boolean)
      .slice(0, 30);

    return {
      type: root.dataset.pageType || '',
      url: location.pathname + location.search,
      title: cleanPageText(document.title, 240),
      description: cleanPageText(document.querySelector('meta[name="description"]')?.content, 500),
      headings,
      controls,
      visibleText: cleanPageText(copy.innerText || copy.textContent, 7000),
      product: config.product || null
    };
  }

  async function ask(question) {
    if (busy) return;
    busy = true;
    send.disabled = true;
    addMessage(question, 'user');
    const typing = addMessage(spanish ? 'Buscando las mejores opciones…' : 'Finding the best options…', 'assistant', 'deoro-ai__typing');
    window.dataLayer?.push({ event: 'ai_chat_message', locale: config.locale || 'en' });
    try {
      if (!config.endpoint) {
        typing.remove();
        addMessage(localAnswer(question), 'assistant');
        return;
      }
      const response = await fetch(config.endpoint.replace(/\/$/, '') + '/api/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: question,
          conversationId,
          locale: config.locale,
          shop: config.shop,
          page: currentPageContext()
        })
      });
      if (!response.ok) throw new Error(`request-${response.status}`);
      const data = await response.json();
      typing.remove();
      if (data.conversationId) {
        conversationId = data.conversationId;
        sessionStorage.setItem('deoro_ai_conversation', conversationId);
      }
      addMessage(data.message || localAnswer(question), 'assistant');
      renderProducts(data.products || []);
      renderHandoff(data.handoff, question);
    } catch (_) {
      typing.remove();
      addMessage(spanish ? 'Lo siento, tuve un problema de conexión. Inténtalo de nuevo o contacta al equipo de De Oro.' : 'Sorry, I had a connection problem. Please try again or contact the De Oro team.', 'error');
    } finally {
      busy = false;
      send.disabled = false;
      input.focus();
    }
  }

  opener.addEventListener('click', () => setOpen(panel.hidden));
  closer.addEventListener('click', () => setOpen(false));
  root.querySelectorAll('[data-ai-prompt]').forEach((button) => button.addEventListener('click', () => ask(button.dataset.aiPrompt)));
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const value = input.value.trim();
    if (!value) return;
    input.value = '';
    ask(value);
  });
  input.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      form.requestSubmit();
    }
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !panel.hidden) setOpen(false); });
})();
